


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { FormField, FormOption } from '@/types';
import FormGroup from './FormGroup.vue';
import { isEmpty, get } from 'lodash';

@Component({
  name: 'up-form',
  components: {
    FormGroup
  }
})
export default class UpForm extends Vue {
  @Prop({ type: [Function, Object], required: true, default: () => ({}) })
  private value!: Function | object;

  @Prop({ type: Array, required: true })
  private fields!: FormField[];

  @Prop({ type: Boolean, default: false })
  private busy!: boolean;

  @Prop({
    type: Object,
    default: () => ({})
  })
  private options!: FormOption;

  private formOptions: FormOption = {
    title: '',
    isCard: true,
    deleteBtnText: 'Delete',
    cancelBtnText: 'Cancel',
    submitBtnText: 'Save',
    cancelable: false,
    deleteable: false
  };

  private formData: object = {};

  hasEventHandler(event: String) {
    // @ts-ignore
    return this.$listeners && this.$listeners[event];
  }

  async onSubmit(e: Event): Promise<any> {
    e.preventDefault();
    this.$emit('submit', this.formData);
  }

  async onDelete() {
    try {
      await this.$confirm('Are you sure?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      this.$emit('delete', this.formData);
    } catch (e) {
      // blank
    }
  }

  async onCancel(): Promise<any> {
    this.$emit('cancel');
  }

  onFormDataChange(key: string, newValue: any) {
    // @ts-ignore
    this.formData[key] = newValue;
    this.$emit('input', this.formData);
  }

  async loadForm() {
    this.updateProp('busy', true);
    this.formOptions = { ...this.formOptions, ...this.options };
    if (this.value instanceof Function) {
      this.formData = await this.value();
    } else {
      this.formData = this.value;
    }
    this.updateProp('busy', false);
  }

  @Watch('value')
  onValueUpdate() {
    this.loadForm();
  }

  @Watch('options')
  onOptionsUpdate() {
    this.loadForm();
  }

  updateProp(key: string, value: any) {
    this.$emit(`update:${key}`, value);
  }

  mounted() {
    this.loadForm();
  }
}
